export default function (params) {
  const data = params.data;
  const width = params.width;
  const height = params.width;
  const config = params.config;
  let svg = params.svg;
  const legendItemSize = params.legendItemSize;
  const legendSpacing = params.legendSpacing;
  const scaleColors = params.scaleColors;

  let current = "";

  let body = svg
  .append("svg")
    .attr("id", "pie-svg")
    .attr("width", width)
    .attr("height", height)
    .append("g")
    .attr("class", "body")
    .attr(
      "transform",
      "translate(" + config.margin.left + "," + config.margin.top + ")"
    )
    .attr("clip-path", "url(#clip)");

  const colors = d3.scaleOrdinal(scaleColors);

  /* ----------------------------尺度轉換------------------------  */
  const arcAngle = d3
    .pie()
    .sort((d, i) => i)
    .value((d) => d.cumulative_ep);

  const getBodyWidth = width;
  const getBodyHeight =
    height - (config.margin.top + config.margin.bottom) ?? 0;
  /* ----------------------------渲染圓餅圖------------------------  */
  const renderSlices = function () {
    const slices = body
      .append("g")
      .classed("pie", true)
      .attr(
        "transform",
        "translate(" + getBodyWidth / 2 + "," + getBodyHeight / 2 + ")"
      )
      .selectAll(".arc")
      .data(arcAngle(data));

    slices
      .enter()
      .append("path")
      .attr("class", (d, i) => "arc arc-" + i)
      .merge(slices)
      .attr("fill", (d, i) => colors(i))
      .transition()
      .duration(config.animateDuration)
      .attrTween("d", arcTween);

    slices.exit().remove();

    const arc = d3
      .arc()
      .outerRadius(config.outerRadius)
      .innerRadius(config.innerRadius);

    function arcTween(d) {
      let currentArc = current;

      if (!currentArc) {
        currentArc = { startAngle: 0, endAngle: 0 };
      }

      const interpolate = d3.interpolate(currentArc, d);
      // 當資料更新時，從目前角度過渡到新角度
      current = interpolate(1);

      return function (t) {
        return arc(interpolate(t));
      };
    }
  };
  /* ----------------------------渲染標籤------------------------  */
  const renderLegend = function () {
    const legend = d3
      .select("#pieLegend")
      .append("svg")
      .attr("id", "legend-svg")
      .attr('width', "180")
      .attr('height', "110")
      .selectAll(".legendItem")
      .data(data);

    // create legend items as circles instead of rectangles
    legend
      .enter()
      .append("circle") // Change this from "rect" to "circle"
      .attr("class", "legendItem")
      .attr("r", legendItemSize / 2) // Set radius of the circle
      .attr("cx", legendItemSize / 2) // Set x coordinate of the circle center
      .attr("cy", (d, i) => (legendItemSize / 2) + (legendItemSize + legendSpacing) * i) // Set y coordinate of the circle center
      .style("fill", (d, i) => colors(i));

    // Adjust the position of legend labels to align with circles
    legend
      .enter()
      .append('text')
      .attr('x', legendItemSize + 20)
      .attr('y', (d, i) => (legendItemSize + legendSpacing) * i + (legendItemSize / 2) + 7) // Adjust y position to align text with circle center
      .text((d) => d.alias);
  }

  function renderChart() {
    renderSlices();
    renderLegend();
  }

  renderChart();
}
